import { transform } from 'sucrase';

/** Strip TS types → runnable JS. Single-file only (no bundling/resolution). */
export function transpile(src: string): string {
  return transform(src, { transforms: ['typescript'], production: true }).code;
}

/** Compile frame TS to a loadable ES-module blob URL. Caller must revoke. */
export function compileScript(src: string): { url: string; revoke: () => void } {
  const js = transpile(src);
  const blob = new Blob([js], { type: 'text/javascript' });
  const url = URL.createObjectURL(blob);
  return { url, revoke: () => URL.revokeObjectURL(url) };
}

/** Strip TS types AND compile JSX (automatic runtime) → runnable JS. */
export function transpileTsx(src: string): string {
  return transform(src, {
    transforms: ['typescript', 'jsx'],
    jsxRuntime: 'automatic',
    production: true,
  }).code;
}

/** Compile TSX to a loadable ES-module blob URL. Caller must revoke. */
export function compileTsx(src: string): { url: string; revoke: () => void } {
  const js = transpileTsx(src);
  const blob = new Blob([js], { type: 'text/javascript' });
  const url = URL.createObjectURL(blob);
  return { url, revoke: () => URL.revokeObjectURL(url) };
}
